<app-navbar-style-two></app-navbar-style-two>

<!-- <div class="banner-area-two">
    <div class="container-fluid">
        <div class="container-max-2">
            <div class="row align-items-center">
                <div class="col-lg-5 col-md-12">
                    <div class="banner-content-two">
                        
                            <h1 class="display-5 fw-bold text-dark mb-4">
                                Boost Your Call <br />
                                Center Productivity <br />
                                with RingPilot
                            </h1>
                            <p class="text-muted mb-4">
                                Maximize customer engagement and boost sales with our ultimate dialer software, designed for efficiency and superior performance in every call.
                            </p>
                            <a href="#" class="btn btn-dark btn-lg d-inline-flex align-items-center gap-2" data-toggle="modal" data-target="#contactModal">
                               Get Started
                            </a>
                    </div>
                </div>
                
                
                <div class="modal fade" id="contactModal" tabindex="-1" role="dialog"
                    aria-labelledby="contactModalLabel" aria-hidden="true" #contactModal>
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="contactModalLabel">Contact Us</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="">
                                    <div class="contact-form">
                                        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                                            <div class="row">
                                                <div class="col-lg-6 col-sm-6">
                                                    <div class="form-group">
                                                        <i class='bx bx-user'></i>
                                                        <input type="text" formControlName="first_name" class="form-control" placeholder="Your First Name" [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }">
                                                        <span *ngIf="f.first_name.invalid && (f.first_name.touched || submitted || f.first_name.dirty)" class="text-danger">
                                                            <span class="text-danger downline" *ngIf=" f.first_name.errors.required">First Name is required</span>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-sm-6">
                                                    <div class="form-group">
                                                        <i class='bx bx-file'></i>
                                                        <input type="text" formControlName="last_name"
                                                            class="form-control" placeholder="Your Last Name" [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }">
                                                        <span *ngIf="f.last_name.invalid && (f.last_name.touched || submitted || f.last_name.dirty)" class="text-danger">
                                                            <span class="text-danger downline" *ngIf=" f.last_name.errors.required">Last Name is required</span>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-sm-6">
                                                    <div class="form-group">
                                                        <i class='bx bx-user'></i>
                                                        <input type="email" formControlName="email" class="form-control" placeholder=" Your E-mail" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                                        <span *ngIf="f.email.invalid && (f.email.touched || submitted || f.email.dirty)" class="text-danger">
                                                            <span class="text-danger downline" *ngIf=" f.email.errors.required">Email is required</span>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-sm-6">
                                                    <div class="form-group">
                                                        <i class='bx bx-phone'></i>
                                                        <input type="text" formControlName="phone_number"
                                                            class="form-control" placeholder="Your Phone" [ngClass]="{ 'is-invalid': submitted && f.phone_number.errors }">
                                                        <span *ngIf="f.phone_number.invalid && (f.phone_number.touched || submitted || f.phone_number.dirty)" class="text-danger">
                                                            <span class="text-danger downline" *ngIf=" f.phone_number.errors.required">Contact is required</span>
                                                        </span>
                                                    </div>
                                                </div>                                                

                                                <div class="col-lg-12 col-md-12">
                                                    <div class="form-group">
                                                        <i class='bx bx-envelope'></i>
                                                        <textarea formControlName="message" class="form-control" cols="30" rows="4" placeholder="Your Message" [ngClass]="{ 'is-invalid': submitted && f.message.errors }"></textarea>
                                                        <span *ngIf="f.message.invalid && (f.message.touched || submitted || f.message.dirty)" class="text-danger">
                                                            <span class="text-danger downline" *ngIf=" f.message.errors.required">Message is required</span>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-lg-12 col-md-12">
                                                    <button type="submit" class="default-btn border-radius">Send Message
                                                        <i class='bx bx-plus'></i></button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container" *ngIf="isposted==1">

                    <div class="row">
                        <div class="col-md-4">
                            <div class="popup-card1">
                                <div class="popup-topray">
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="popup-circle mt-5 d-flex justify-content-center align-items-center">
                                        <span class="material-symbols-outlined popicon">
                                            check
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center align-items-center mt-4">
                                    <h4 class="text-center">Thank You!</h4>
                                </div>
                                <div class="d-flex justify-content-center align-items-center popup-insidediv">
                                    <p class="text-center">We appreciate you contacting us. Our support team will get back in touch with you soon!Have a great day!
                                    </p>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <button type="button" class="popupbtn" (click)="Close()">CLOSE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <div class="banner-img-2">
                        <img src="assets/img/home-two/home-two-img.png" alt="Fax Broadcasting Solution">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="banner-bottom-shape">
        <div class="shape-one wow fadeInUp" data-wow-delay=".3s"><img src="assets/img/home-two/home-two-shape1.png"
                alt="Images"></div>
        <div class="shape-two wow fadeInUp" data-wow-delay=".5s"><img src="assets/img/home-two/home-two-shape2.png"
                alt="Images"></div>
        <div class="shape-three wow fadeInUp" data-wow-delay=".7s"><img src="assets/img/home-two/home-two-shape3.png"
                alt="Images"></div>
        <div class="banner-dots1"><img src="assets/img/home-two/home-two-dots.png" alt="Images"></div>
        <div class="banner-dots2"><img src="assets/img/home-two/home-two-dots2.png" alt="Images"></div>
    </div>
</div> -->

<div class="container-fluid">
    <div class="row align-items-center min-vh-100">
      <!-- Left Text Column -->
      <div class="col-lg-6 p-5">
        <h1 class="highlight-title">
            Boost Your Call <br>
            Center Productivity with<br>
            RingPilot
        </h1>
        <p class="sub-text mt-4">
            Maximize customer engagement and boost sales with our ultimate dialer software, designed for efficiency and superior performance in every call.
        </p>
        <!-- <button class="btn btn-custom mt-4">
          <i class="bi bi-fire"></i> Get Started
        </button> -->
        <button class="btn start-btn fw-bold d-flex align-items-center justify-content-center px-4" routerLink="/contact">
            <i class="bi bi-fire me-1"></i> Subscribe Now
        </button>
      </div>
  
      <!-- Right Image Column -->
      <div class="col-lg-6 image-container d-none d-lg-block">
        <!-- Background image in CSS -->
        <img src="assets/img/home-two/ringpilot-background-image.jpg" width="75%" height="auto" alt="Ringpilot Solution">
      </div>
    </div>
</div>

<!-- <div class="about-widget-area pt-50 pb-70">
  <div class="container-fluid">
      <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
              <div class="about-widget-img">
                  <img src="assets/img/about/about-img4.png" alt="">
              </div>
          </div>

          <div class="col-lg-6 col-md-12">
              <div class="about-widget-content">
                  <div>
                      <h2>Who We Are</h2>
                  </div>
                  <p>
                      At RingPilot, we are passionate about transforming the way businesses communicate. Founded with a 
                      vision to empower organizations through cutting-edge technology, RingPilot has grown into a leading
                      cloud-based contact center platform trusted by over 300 businesses across diverse industries including
                      insurance, healthcare, real estate, banking, and more.
                  </p>
                  <p>
                      Our mission is simple: to help businesses connect better, sell smarter, and serve customers 
                      faster — all while ensuring security, compliance, and ease of use.
                  </p>
                  <div class="about-video">
                      <a href="https://www.youtube.com/watch?v=pvbUDDOfRlM" class="video-btn popup-btn"><i class='flaticon-forward'></i><span>Play Video </span></a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->


<!--------Introduction------------>
<div class="container">
    <div class="row align-items-center ">
      <!-- Left Text Column -->
      <div class="col-lg-6 p-5">
         <img src="assets/img/home-two/intro-image.jpeg" alt="RingPilot Introduction" class="img-fluid rounded shadow-sm" />
      </div>
  
      <!-- Right Image Column -->
      <div class="col-sm-6 p-5">
        <h2 class="mb-3">Introduction</h2>
        <p>
          Welcome to <strong>RingPilot</strong>, where cutting-edge technology meets unparalleled efficiency. 
          Our advanced call center dialer software is meticulously designed to transform your customer interactions, 
          streamline operations, and significantly increase your team's productivity.
        </p>
        <p>
          With RingPilot, you can expect a seamless blend of innovation and performance, 
          tailored to meet the unique demands of modern call centers.
        </p>
      </div>
    </div>
</div>


<!-- <div class="container-fluid my-5">
    <div class="row align-items-center">
      
      <div class="col-sm-6 text-center">
        <img src="assets/img/home-two/intro-image.jpeg" alt="RingPilot Introduction" class="img-fluid rounded shadow-sm" />
      </div>
  
      <div class="col-sm-6">
        <h2 class="mb-3">Introduction</h2>
        <p>
          Welcome to <strong>RingPilot</strong>, where cutting-edge technology meets unparalleled efficiency. 
          Our advanced call center dialer software is meticulously designed to transform your customer interactions, 
          streamline operations, and significantly increase your team's productivity.
        </p>
        <p>
          With RingPilot, you can expect a seamless blend of innovation and performance, 
          tailored to meet the unique demands of modern call centers.
        </p>
      </div>
      
    </div>
</div> -->
  

<!--------- Key Benefits -------->
<div class="service-area-two">
    <div class="container">
        <div class="text-center">
            <h2>Key Benefits</h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Efficiency</a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon7.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p> Automate dialing processes to save time and increase agent talk time, ensuring that your team can focus on what truly matters—engaging with customers.</p>
                    <!-- <a target="_blank" routerLink="/services-details" class="learn-btn">Demo<i class='bx bx-plus'></i></a> -->
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Scalability</a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon8.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p>Easily scale your operations to handle high call volumes without compromising quality, making 
                        RingPilot the perfect solution for growing businesses.</p>
                    <!-- <a target="_blank" routerLink="/services-details" class="learn-btn">Learn more <i class='bx bx-plus'></i></a> -->
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="services-item">
                    <h3><a routerLink="/services-details">Cost-Effective </a></h3>
                    <div class="services-item-img">
                        <a routerLink="/services-details"><img src="assets/img/service/service-icon9.png"
                                alt="Images"></a>
                        <div class="img-circle"></div>
                    </div>
                    <p>Optimize resources and reduce operational costs with our intelligent dialing solutions, 
                        providing an excellent return on investment.</p>
                    <!-- <a  target="_blank" routerLink="/services-details" class="learn-btn">Learn more <i class='bx bx-plus'></i></a> -->
                </div>
            </div>
        </div>
    </div>

    <div class="service-two-shape">
        <div class="shape-in1"><img src="assets/img/shape/shape9.png" alt="Images"></div>
        <div class="shape-in2"><img src="assets/img/shape/shape10.png" alt="Images"></div>
        <div class="shape-in3"><img src="assets/img/shape/shape11.png" alt="Images"></div>
        <div class="shape-in4"><img src="assets/img/shape/shape7.png" alt="Images"></div>
        <div class="shape-in5"><img src="assets/img/shape/shape12.png" alt="Images"></div>
    </div>
</div>


<!------- Features overview------->

<section class="py-5" style="background-color: #f5f8ff;">
    <div class="container">
      <h2 class="text-center fw-bold mb-5">Our Amazing Features</h2>
      <div class="row g-4">
        <!-- Feature Item -->
        
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-telephone-fill fs-1 text-primary"></i>
            </div>
            <h5 class="fw-semibold">Auto Dialer</h5>
            <p>Automatically dial a large number of leads and connect them to available agents, saving time and effort.</p>
          </div>
        </div>
        <!-- <div class="col-md-4">
            <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
              <div class="icon-wrapper mb-3">
                <i class="bi bi-telephone-fill fs-1"></i>
              </div>
              <h5 class="fw-semibold">Auto Dialer</h5>
              <p>
                Automatically dial a large number of leads and connect them to available agents, saving time and effort.
              </p>
            </div>
          </div> -->
          
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-clock-history fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">Predictive Dialer</h5>
            <p>Utilize advanced algorithms to predict the best times to call, ensuring higher connect rates and reduced idle time.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-cpu-fill fs-1 text-info"></i>
            </div>
            <h5 class="fw-semibold">AI Dialer</h5>
            <p>Leverage AI to manage lead distribution and optimize dialing speeds based on real-time data.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-voicemail fs-1 text-warning"></i>
            </div>
            <h5 class="fw-semibold">Ringless Voicemail</h5>
            <p>Send pre-recorded messages directly to voicemail inboxes without ringing the phone.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-mouse fs-1 text-danger"></i>
            </div>
            <h5 class="fw-semibold">Click-to-Call</h5>
            <p>Enable web-based calling directly from your website for better customer engagement.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-cloud-check-fill fs-1 text-primary"></i>
            </div>
            <h5 class="fw-semibold">Hosted PBX</h5>
            <p>A cloud-based PBX with advanced call management for flexible communication.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-ui-checks fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">Multi-campaign Management</h5>
            <p>Manage multiple campaigns efficiently, ensuring optimal performance and resource use.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-speedometer2 fs-1 text-info"></i>
            </div>
            <h5 class="fw-semibold">Agent Performance Dashboard</h5>
            <p>Monitor and analyze agent performance in real-time with detailed insights.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-person-gear fs-1 text-warning"></i>
            </div>
            <h5 class="fw-semibold">Manager Panel</h5>
            <p>Tools for managers to oversee operations, manage agents, and ensure smooth workflow.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-person-badge-fill fs-1 text-danger"></i>
            </div>
            <h5 class="fw-semibold">Supervisor Panel</h5>
            <p>Allow supervisors to monitor calls and assist agents for high-quality interactions.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-diagram-3-fill fs-1 text-primary"></i>
            </div>
            <h5 class="fw-semibold">Agency Panel</h5>
            <p>Manage multiple agencies under one platform for centralized control and flexibility.</p>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="feature-card bg-white text-center p-4 rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-graph-up-arrow fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">Campaign Performance</h5>
            <p>Track and analyze campaign performance with detailed reports and analytics.</p>
          </div>
        </div>
      </div>
    </div>
</section>

<!-------- Why Call Center Dialers Are... ------->
<div class="faq-area pt-50 pb-70">
    <div class="container">
        <div class="text-center">
            <h2 class="mb-5 fw-bold">Why Call Center Dialers Are Crucial for Your Business
            </h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-6 col-md-12">
                <div class="faq-accordion">
                    <ul class="accordion">
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i>Maximize Productivity</a>
                            <div class="accordion-content">
                                <p> Call center dialers automate the dialing process, allowing agents to focus on live interactions rather than manual dialing. This boosts productivity and ensures more calls are made in less time.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i> Enhance Customer Experience </a>
                            <div class="accordion-content">
                                <p>By reducing wait times and ensuring faster connections, call center dialers significantly improve the customer experience, leading to higher satisfaction and loyalty.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i>Scalable Solutions </a>
                            <div class="accordion-content">
                                <p> As your business grows, call center dialers can easily scale to accommodate increased call volumes and additional agents, ensuring seamless expansion.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title active" href="javascript:void(0)"><i
                                    class='bx bx-chevron-down'></i> Regulatory Compliance
                            </a>
                            <div class="accordion-content show">
                                <p>Modern dialers are equipped with features to ensure compliance with industry regulations, protecting your business from legal issues and maintaining customer trust.
                                </p>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-accordion">
                    <ul class="accordion">
                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i> Minimized Idle Time
                            </a>
                            <div class="accordion-content">
                                <p> Predictive and AI-driven dialers optimize call timing, reducing agent idle time and ensuring they are always engaged in productive activities.</p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i> Streamlined Campaign Management </a>
                            <div class="accordion-content">
                                <p> Manage multiple campaigns effortlessly with features that allow for easy switching and monitoring, ensuring each campaign runs smoothly and effectively.</p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i> Enhanced Workforce Management </a>
                            <div class="accordion-content">
                                <p>Tools like agent performance dashboards and manager panels provide better oversight and management capabilities, ensuring high performance and quick identification of training needs.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i>Secure Communications</a>
                            <div class="accordion-content">
                                <p> Advanced security features ensure that all communications and data are protected, maintaining the integrity and confidentiality of customer information.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i>Cost Efficiency </a>
                            <div class="accordion-content">
                                <p> Automation reduces the need for extensive manual labor, lowering operational costs and allowing businesses to manage higher call volumes without additional staffing.
                                </p>
                            </div>
                        </li>

                        <li class="accordion-item">
                            <a class="accordion-title" href="javascript:void(0)"><i class='bx bx-chevron-down'></i>Data-Driven Insights </a>
                            <div class="accordion-content">
                                <p>Integrated analytics provide real-time data on call performance, agent efficiency, and customer interactions. This helps businesses make informed decisions and continuously improve their operations.
                                </p>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-------- contact us ----------->
<div class="container my-5">
    <div class="row text-center">
      <div class="col-md-3 mb-4">
        <div class="stats-box">
          <div class="stat-icon text-success">
            <i class="bi bi-card-checklist"></i>
          </div>
          <h4 class="text-danger">0+</h4>
          <p class="mb-0">Completed Projects</p>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="stats-box">
          <div class="stat-icon text-success">
            <i class="bi bi-emoji-smile"></i>
          </div>
          <h4 class="text-danger">0+</h4>
          <p class="mb-0">Happy Clients</p>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="stats-box">
          <div class="stat-icon text-success">
            <i class="bi bi-layout-text-window-reverse"></i>
          </div>
          <h4 class="text-danger">0+</h4>
          <p class="mb-0">Ongoing Projects</p>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="stats-box">
          <div class="stat-icon text-success">
            <i class="bi bi-award"></i>
          </div>
          <h4 class="text-danger">0+</h4>
          <p class="mb-0">Winning Awards</p>
        </div>
      </div>
    </div>

    <div class="cta-section">
      <h4 class="fw-bold">Have any question about us?</h4>
      <p class="text-muted">Don't hesitate to contact us.</p>
      <div class="d-flex justify-content-center ">
        <button class="btn start-btn fw-bold d-flex align-items-center justify-content-center mt-3px-4" routerLink="/contact">
          <i class="bi bi-telephone me-1"></i> Contact Us
        </button>
      </div>
    </div>
  </div>
  


<!-- <div class="about-area-two pb-70">
    <div class="container-fluid">
        <div class="container-max">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="about-img-2">
                        <img src="assets/img/about/about-img2.png" alt="Fax blast services">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-content-two">
                        <div class="section-title">
                            <span class="sp-before sp-after">About Us</span>
                            <h2>Grow Business With Fax Broadcasting Solution</h2>
                        </div>
                        <h3>With 7 years of experience, we are now focused on adopting the best technology and evolving strategies to deliver exceptional results for businesses.</h3>
                        <p>Our commitment is to consistently provide outstanding results for businesses. Leveraging FreeSWITCH, we possess a robust capability for rapidly transmitting a large volume of faxes. Our network empowers you to achieve an output of 20,000 faxes per minute on your dedicated instance.</p>
                        <div class="row">
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>01</span>
                                    <p>Efficient</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>02</span>
                                    <p>Seamless</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>03</span>
                                    <p>Dependable</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>04</span>
                                    <p>Secure</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>05</span>
                                    <p>Customizable</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 pr-0">
                                <div class="about-list">
                                    <i class='bx bx-check'></i>
                                    <span>06</span>
                                    <p>Affordable</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="counter-area-two pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>2 Million</h3>
                    <p>Faxes per month</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>80%</h3>
                    <p>Success rate</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>10+</h3>
                    <p>TEAM MEMBERS</p>
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="counter-card">
                    <h3>100%</h3>
                    <p>Uptime & dedicated Support</p>
                </div>
            </div>
        </div>
    </div>

    <div class="counter-shape-top"><img src="assets/img/counter/counter-shape.png" alt="Images"></div>
</div> -->


<!---------What Makes RingPilot More Impressive ----------->
<div class="service-another pb-70">
    <div class="container">
        <div class="text-center">
            <h2>What Makes RingPilot<br> More Impressive?</h2>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i
                            class="flaticon-research service-icon service-icon-bg1"></i></a>
                    <h3><a routerLink="/services-details">Advanced Analytics</a></h3>
                    <p>Gain deep insights into your call center operations with our advanced analytics tools, helping you
                         make informed decisions. Our analytics provide actionable data that can drive improvements across 
                         your entire operation</p>
                    <!-- <a target="_blank" routerLink="/services-details/medical-healthcare" class="learn-btn">Learn more <i
                            class='bx bx-plus'></i></a> -->
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i
                            class="flaticon-headphones service-icon service-icon-bg"></i></a>
                    <h3><a routerLink="/services-details">Customizable Workflows</a></h3>
                    <p>Tailor workflows to meet the specific needs of your business, enhancing efficiency 
                        and productivity. Our customizable workflows ensure that RingPilot fits seamlessly 
                        into your existing processes
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i class="flaticon-caution service-icon service-icon-bg2"></i></a>
                    <h3><a routerLink="/services-details">Seamless Integrations</a></h3>
                    <p>Easily integrate RingPilot with your existing CRM, helpdesk, and other business tools to create
                         a unified system. This integration capability ensures that all your tools work together harmoniously.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i
                            class="flaticon-big-data service-icon service-icon-bg3"></i></a>
                    <h3><a routerLink="/services-details">User-Friendly Interface</a></h3>
                    <p>Our intuitive interface ensures that your team can quickly adopt and effectively use RingPilot 
                        without extensive training. Ease of use is a core feature, making onboarding a breeze.

                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i class="flaticon-money service-icon service-icon-bg4"></i></a>
                    <h3><a routerLink="/services-details">High Reliability</a></h3>
                    <p>With 99.99% uptime, RingPilot ensures that your call center operations run smoothly without 
                        interruptions. Our robust infrastructure guarantees that you can rely on RingPilot at all times.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-another-card service-card-height">
                    <a routerLink="/services-details"><i class="flaticon-share service-icon service-icon-bg5"></i></a>
                    <h3><a routerLink="/services-details">Data Security</a></h3>
                    <p>We prioritize your data security with robust encryption and compliance with industry standards, 
                        ensuring your information is always protected. Our commitment to security means you can trust us
                         with your most sensitive data.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="service-another-shape">
        <div class="shape-1"><img src="assets/img/shape/shape13.png" alt="Images"></div>
        <div class="shape-2"><img src="assets/img/shape/shape11.png" alt="Images"></div>
        <div class="shape-3"><img src="assets/img/shape/shape10.png" alt="Images"></div>
        <div class="shape-4"><img src="assets/img/shape/shape9.png" alt="Images"></div>
        <div class="shape-5"><img src="assets/img/shape/shape7.png" alt="Images"></div>
        <div class="shape-6"><img src="assets/img/shape/shape12.png" alt="Images"></div>
    </div>
</div>

<!-- <div class="strip">
        <div class="strip-width">
          <div class="row align-items-center">
            <div class="col-lg-8 col-md-12">
                <div class="strip-form">
                    <h2>5 FREE FAXES & FREE DEMO</h2>
                  </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="col-lg-12 col-md-12 btn-strip">
                <button type="submit" class="default-btns border-radius" [routerLink]="['/sign-up']">Sign Up <i class='bx bx-plus'></i></button>
             </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="mission-area pt-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="mission-content">
                    <div class="section-title">
                        <span class="sp-before sp-after">Mission</span>
                        <h2 class="h2-color2">We Strive to Exceed Your Expectations</h2>
                    </div>
                    <p>Unlock the potential of our outstanding services. We consistently exceed your expectations,
                        delivering results beyond compare</p>
                    <div class="row">
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>01</span>
                                <p>24X7 Support Team</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>02</span>
                                <p>Priority Support</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>03</span>
                                <p>Easy OnBoarding</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>04</span>
                                <p>Technology Experience</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>05</span>
                                <p>Business Growth</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 pr-0">
                            <div class="mission-list">
                                <i class='bx bx-check'></i>
                                <span>06</span>
                                <p>Business Vision</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="mission-img">
                    <img src="assets/img/mission-img.png" alt="Fax Broadcasting Software">
                </div>
            </div>
        </div>
    </div>

    <div class="mission-shape">
        <div class="shape1"><img src="assets/img/shape/shape13.png" alt="Images"></div>
        <div class="shape2"><img src="assets/img/shape/shape11.png" alt="Images"></div>
        <div class="shape3"><img src="assets/img/shape/shape12.png" alt="Images"></div>
        <div class="shape4"><img src="assets/img/shape/shape9.png" alt="Images"></div>
    </div>
</div> -->

<!-- <div class="services-details-area">
    <div class="container">
        <h3 class="row inner-title text-center">Recent Faxes Sent</h3>
    </div>
</div>

<div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/1.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/6.png" alt="Images">
                </div>
                <div class="brand-logo-item">
                    <img src="assets/img/brand/7.png" alt="Images">
                </div>
                <div class="brand-logo-item">
                    <img src="assets/img/brand/8.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div> -->

<!----strip--->
<!-- <div class="data-table-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="data-table-content">
                    <h2>We Like to Start Your Project With Us</h2>
                    <a routerLink="/contact" class="default-btn">Get started <i class='bx bx-plus'></i></a>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="data-table-img">
                    <img src="assets/img/data-table-img.png" alt="Images">                    
                </div>
            </div>

        </div>
    </div>
</div> -->

<!------The Value of Integrating Dialer Software------>
<div class="container my-5 position-relative">

  <!-- Scroll Buttons -->
  <button class="btn scroll-btn left" (click)="scrollCards(-1)">
    ←
  </button>
  <button class="btn scroll-btn right" (click)="scrollCards(1)">
    →
  </button>

  <!-- Scrollable Card Row -->
  <div class="d-flex">
    
    <div class=" intro-card  p-4 flex-shrink-0 shadow-sm d-flex align-items-center">
      <div class="">
        <h2 class="fw-bold mt-3 mb-4">The Value of <br>Integrating Dialer<br> Software</h2>
        <!-- <button class="btn btn-primary mt-3">Check it out</button> -->
        <button class="btn start-btn3 fw-bold d-flex align-items-center justify-content-center mt-3px-4" routerLink="/contact">
          <i class="bi bi-fire"></i> Check it out
        </button>
      </div>
    </div>

     <div #cardContainer class="carousel-container d-flex overflow-auto">
      <div class="card carousel-card p-4 m-2 flex-shrink-0 shadow-sm" *ngFor="let card of cards">
        <i class="{{ card.icon }} fs-3 text-primary mb-2"></i>
        <h5 class="fw-bold">{{ card.title }}</h5>
        <p class="text-muted">{{ card.text }}</p>
        <!-- <a href="#" class="text-primary fw-bold mt-2 d-inline-block">Know more &rarr;</a> -->
      </div>
     </div>
  </div>
</div>



<!--------- Industries We Cater To --------->
<div class="work-area-two pt-100 pb-70">
    <div class="container">
        <div class="text-center">
            <h2>Industries We Cater To</h2>
            <p>Our versatile dialer software is designed to meet 
                the unique needs of various industries, ensuring that 
                no matter your sector, RingPilot can enhance your call 
                center operations. We cater to</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-12">
                <div class="work-item-list">
                    <ul>
                        <li class="text-end">
                            <h3><a href="/vertical/insurance">Insurance</a><span>1</span></h3>
                            <p>Streamline policy sales, renewals, and customer service with efficient call handling and data management.<a href="/vertical/insurance" class="text-primary d-inline-block">Know more &rarr;</a></p>
                        </li>
                        <li class="text-end">
                            <h3><a href="/vertical/real-estate">Real Estate</a><span>2</span></h3>
                            <p>Boost property sales and client interactions with seamless call management and lead tracking features.<a href="/vertical/real-estate" class="text-primary d-inline-block">Know more &rarr;</a></p>
                        </li>
                        <li class="text-end">
                            <h3><a href="/vertical/banking">Finance</a><span>3</span></h3>
                            <p>Improve financial service delivery with seamless, secure, and efficient call routing and management technologies.<a href="/vertical/banking" class="text-primary d-inline-block">Know more &rarr;</a> </p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="work-img-2">
                    <img src="assets/img/work-img.png" alt=" Online Bulk Fax Service">
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="work-item-list-2">
                    <ul>
                        <li>
                            <h3><span>4</span><a href="/vertical/consulting">Consulting</a></h3>
                            <p>Optimize consulting workflows with intelligent call management that boosts collaboration and client satisfaction.<a href="/vertical/consulting" class="text-primary d-inline-block">Know more &rarr;</a></p>
                        </li>
                        <li>
                            <h3><span>5</span><a href="/vertical/call-center">Call Center</a></h3>
                            <p>Boost efficiency and customer satisfaction with smart, secure, and reliable call center solutions. <a href="/vertical/call-center" class="text-primary d-inline-block">Know more &rarr;</a></p>
                        </li>
                        <li>
                            <h3><span>6</span><a href="/vertical/sells-marketing">Sells/Marketing</a></h3>
                            <p>Enhance lead generation and customer engagement with powerful, integrated sales and marketing platforms.<a href="/vertical/sells-marketing" class="text-primary d-inline-block">Know more &rarr;</a></p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!----------- why choose ringpilot --------->
<section class="py-5 bg-light text-center">
    <div class="container">
      <h2 class="mb-5 fw-bold">Why Choose RingPilot?</h2>
      <div class="row g-4">
        <div class="col-md-4">
          <div class="p-4 bg-white cta-card rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-people-fill fs-1 text-primary"></i>
            </div>
            <h5 class="fw-semibold">Trusted by Industry Leaders</h5>
            <p>Over 300 businesses rely on RingPilot for their call center needs. Our proven track record speaks volumes about our reliability and effectiveness.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-4 bg-white cta-card rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-headset fs-1 text-success"></i>
            </div>
            <h5 class="fw-semibold">24/7 Support</h5>
            <p>Our dedicated support team is available around the clock to assist you with any issues. We are committed to providing exceptional customer service and support.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-4 bg-white cta-card rounded shadow-sm h-100">
            <div class="mb-3">
              <i class="bi bi-shield-lock-fill fs-1 text-warning"></i>
            </div>
            <h5 class="fw-semibold">Secure and Reliable</h5>
            <p>We prioritize data security with encrypted servers to protect your information. Our robust security measures ensure that your data is always safe.</p>
          </div>
        </div>
      </div>
    </div>
</section>

<!------- testimonials ----------->
<div class="container py-5">
    <div class="text-center mb-5">
      <h2 class="fw-bold text-dark">Whats Our Clients Said</h2>
      <h2 class="fw-bold text-dark">About <span class="text-orange">RINGPILOT</span></h2>
    </div>
  
    <div class="row justify-content-center">

      <div class="col-md-5 col-sm-12 mb-4">
        <div class="testimonial-card border border-orange rounded-4 p-4 text-center h-100">
          <img src="assets/img/home-two/person2.jpg" alt="CEO Photo" class="img-fluid rounded-circle mb-3" width="120">
          <p class="text-muted">
            "RingPilot has transformed our call center operations. Our agents are more productive, and our sales have increased significantly."
          </p>
          <h5 class="fw-bold mb-0">CEO, Leading BPO</h5>
        </div>
      </div>

      <div class="col-md-5 col-sm-12 mb-4">
        <div class="testimonial-card border border-success rounded-4 p-4 text-center h-100">
          <img src="assets/img/home-two/person3.jpg" alt="Sales Director Photo" class="img-fluid rounded-circle mb-3" width="120">
          <p class="text-muted">
            "The AI Dialer is a game-changer. It has optimized our lead management and improved our overall efficiency."
          </p>
          <h5 class="fw-bold mb-0">Sales Director, Solar Energy Company</h5>
        </div>
      </div>
    </div>
</div>

<!------- Get to know about ----------->
<div class="container my-5">
    <h2 class="mb-4">Get to know about <span style="color: #FF5A2C;">RINGPILOT</span></h2>
  
    <div class="row align-items-start">

      <div class="col-md-6">
        <div *ngFor="let faq of faqs; let i = index" class="faq-item p-2 mb-3 border rounded bg-light">
          <div class="faq-header d-flex justify-content-between align-items-center">
            <span class="fw-bold">{{ faq.question }}</span>
            <span
              class="faq-toggle fs-4"
              style="cursor:pointer;"
              (click)="toggleFaq(i)"
            >
              {{ selectedFaqIndex === i ? '×' : '+' }}
            </span>
          </div>
          <div class="faq-content mt-2" *ngIf="selectedFaqIndex === i">
            <div style="height: 1px; background-color: #ff5a2c; margin-bottom: 8px;"></div>
            <p>{{ faq.answer }}</p>
          </div>
        </div>
      </div>
  
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <img src="assets/img/home-two/about-image.png" alt="about-img">
      </div>
    </div>
</div>
  
  

<!------- Call TO Action ----------->

<!-- <div class="centerdiv">
    <div class="card custom-card">
        <div class="card-body">
            <div class="row w-100">
                <div class="col-md-12 mt-4">
                    <p class="pstyle text-center fontsize">SUBSCRIBE TO OUR NEWSLETTER</p>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-8 d-flex justify-content-center align-items-center pattern">
                        <div class="input-group position-relative">
                            <input type="email" class="form-control custom-email-input rounded-borders"
                                placeholder="Enter your email">
                            <button class="custom-subscribe-button rounded-borders" type="button">Subscribe</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<section class="py-5 subscription-section">
    <div class="container text-center text-white">
      <h2 class="fw-bold mb-4 text-white">We always try to be the best<br>support to you as possible</h2>
      
      <div class="row justify-content-center">
        <div class="col-md-4 mb-2">
          <input type="email" class="form-control email-input fw-bold" placeholder="hello@jexsa.com">
        </div>
        <div class="col-auto mb-2">
          <button class="btn start-btn2 fw-bold d-flex align-items-center justify-content-center px-4" routerLink="/contact">
            <i class="bi bi-fire"></i> Subscribe Now
          </button>
        </div>
      </div>
    </div>
</section>
  

<!----Our Latest News--------->
<div class="container py-5">
    <h2 class="text-center fw-bold mb-5">Our Latest News</h2>
    <div class="row g-4">
      
      <!-- Card 1 -->
      <div class="col-md-4">
        <div class="bg-white p-3 news-card">
          <img src="assets/img/home-two/person1.jpg" alt="News 1" class="news-image">
          <div class="mt-3 text-muted small d-flex align-items-center gap-2">
            <i class="bi bi-calendar-event"></i> Oct 14, 2023
          </div>
          <h5 class="fw-bold mt-2">50 world-changing work, We lost in the 2010s</h5>
          <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="d-flex align-items-center gap-2">
              <img src="https://randomuser.me/api/portraits/women/44.jpg" class="author-img" alt="">
              <span>Sarah Taylor</span>
            </div>
            <div class="read-more-btn">
              <i class="bi bi-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Card 2 -->
      <div class="col-md-4">
        <div class="bg-white p-3 news-card">
          <img src="assets/img/home-two/person2.jpg" alt="News 2" class="news-image">
          <div class="mt-3 text-muted small d-flex align-items-center gap-2">
            <i class="bi bi-calendar-event"></i> Oct 16, 2023
          </div>
          <h5 class="fw-bold mt-2">Don’t buy a tech gift until you read these rules</h5>
          <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="d-flex align-items-center gap-2">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" class="author-img" alt="">
              <span>Michel John</span>
            </div>
            <div class="read-more-btn">
              <i class="bi bi-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Card 3 -->
      <div class="col-md-4">
        <div class="bg-white p-3 news-card">
          <img src="assets/img/home-two/person3.jpg" alt="News 3" class="news-image">
          <div class="mt-3 text-muted small d-flex align-items-center gap-2">
            <i class="bi bi-calendar-event"></i> Oct 18, 2023
          </div>
          <h5 class="fw-bold mt-2">The golden rule of buying a phone as a gift</h5>
          <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="d-flex align-items-center gap-2">
              <img src="https://randomuser.me/api/portraits/women/22.jpg" class="author-img" alt="">
              <span>Lucy Eva</span>
            </div>
            <div class="read-more-btn">
              <i class="bi bi-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
  
    </div>
        <div class="mt-2 mb-2">
            <p class="text-center text-secondary mt-5 mb-5">
                Insights to help you do what you do better, faster and more profitably. 
                <a href="/blog" class="text-danger text-decoration-none fw-semibold">Read Full Blog</a>
              </p>
        </div>
  </div>


  
  

<app-footer-style-two></app-footer-style-two>